import { Link } from "react-router-dom";
import { products } from "@/data/products";
import { ArrowRight, QrCode } from "lucide-react";

const LOGO_URL =
  "https://balance8.co.uk/cdn/shop/files/Logo_02_b2cedfc7-a338-4500-a9d9-bd23002b1cb6.png?v=1728339609";

export function HomePage() {
  return (
    <div className="min-h-screen bg-[#fafafa] font-[Poppins]">
      <header className="pt-10 pb-4 flex justify-center px-6">
        <img src={LOGO_URL} alt="Balance8" className="h-12 w-auto" />
      </header>

      <main className="max-w-xl mx-auto px-6 pb-16">
        <div className="text-center mb-10">
          <h1 className="text-xl font-light text-[#020912] mb-1">
            Product QR Links
          </h1>
          <p className="text-xs text-gray-400 tracking-wide uppercase">
            Internal testing page
          </p>
        </div>

        <div className="space-y-3">
          {products.map((product) => (
            <div
              key={product.gtin}
              className="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-all border border-gray-100 flex items-center justify-between group"
            >
              <Link
                to={`/${product.gtin}`}
                className="flex-1 min-w-0"
              >
                <h3 className="font-medium text-[#020912] text-sm leading-snug group-hover:text-gray-700 transition-colors">
                  {product.name}
                </h3>
              </Link>
              <div className="flex items-center gap-1 shrink-0 ml-3">
                <Link
                  to={`/${product.gtin}/qr`}
                  className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                  title="View QR code"
                >
                  <QrCode className="h-4 w-4 text-gray-400 hover:text-[#020912] transition-colors" />
                </Link>
                <Link
                  to={`/${product.gtin}`}
                  className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                  title="View product page"
                >
                  <ArrowRight className="h-4 w-4 text-gray-300 group-hover:text-gray-600 transition-colors" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </main>

      <footer className="py-6 text-center border-t border-gray-100">
        <p className="text-[10px] text-gray-300 tracking-widest uppercase">
          Redefining Complete Wellness
        </p>
      </footer>
    </div>
  );
}
